const BlogIndex = ({ title, list = [] }) => {
  return (
    <div className="w-full lg:w-[280px]">
      <div className="border p-[24px] rounded-[12px]">
        <p className="font-[CentraNo2] title font-bold">{title}</p>
        <ul className="list-disc pl-6 py-4">
          {list.map((item, i) => (
            <li
              key={i}
              className="cursor-pointer"
              onClick={() =>
                document.getElementById(`topic-${i + 1}`)?.scrollIntoView()
              }
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlogIndex;
